<div
class="fusion-fullwidth fullwidth-box fusion-builder-row-1 fusion-parallax-none nonhundred-percent-fullwidth non-hundred-percent-height-scrolling"
style='background-color: rgba(255,255,255,0);background-image: url("/wp-content/uploads/2015/12/home-244125289-1024x630.jpg");background-position: center bottom;background-repeat: no-repeat;padding-top:150px;padding-right:30px;padding-bottom:0px;padding-left:30px;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;'>
<div class="fusion-builder-row fusion-row ">
  <div
    class="fusion-layout-column fusion_builder_column fusion_builder_column_1_1 fusion-builder-column-0 fusion-one-full fusion-column-first fusion-column-last 1_1"
    style='margin-top:0px;margin-bottom:0px;'>
    <div class="fusion-column-wrapper"
      style="padding: 0px 0px 0px 0px;background-position:left top;background-repeat:no-repeat;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;"
      data-bg-url="">
      <style type="text/css">
        @media only screen and (max-width:800px) {
          .fusion-title.fusion-title-1 {
            margin-top: 10px !important;
            margin-bottom: 10px !important;
          }
        }
      </style>
      <div class="fusion-title title fusion-title-1 fusion-sep-none fusion-title-text fusion-title-size-one"
        style="margin-top:0px;margin-bottom:10px;">
        <h1 class="title-heading-left" style="margin:0;"></h1>
      </div>
      <div class="fusion-sep-clear"></div>
      <div class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto;margin-right: auto;margin-top:100px;"></div>
      <div
        class="fusion-section-separator section-separator big-half-circle fusion-section-separator-with-offset"
        style="padding:0;margin-left:calc( (100vw - 100% ) / -2 );margin-right:calc( (100vw - 100% ) / -2  );">
        <svg class="fusion-big-half-circle-candy" xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%"
          height="100" viewBox="0 0 100 100" preserveAspectRatio="none" style="fill:#ffffff;padding:0;">
          <path d="M0 100 C40 0 60 0 100 100 Z"></path>
        </svg></div>
      <div class="fusion-clearfix"></div>
    </div>
  </div>
</div>
</div>
<style type="text/css">
.fusion-fullwidth.fusion-builder-row-1 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link),
.fusion-fullwidth.fusion-builder-row-1 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):before,
.fusion-fullwidth.fusion-builder-row-1 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):after {
  color: #ffa626;
}

.fusion-fullwidth.fusion-builder-row-1 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):hover,
.fusion-fullwidth.fusion-builder-row-1 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):hover:before,
.fusion-fullwidth.fusion-builder-row-1 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):hover:after {
  color: #ffa626;
}

.fusion-fullwidth.fusion-builder-row-1 .pagination a.inactive:hover,
.fusion-fullwidth.fusion-builder-row-1 .fusion-filters .fusion-filter.fusion-active a {
  border-color: #ffa626;
}

.fusion-fullwidth.fusion-builder-row-1 .pagination .current {
  border-color: #ffa626;
  background-color: #ffa626;
}

.fusion-fullwidth.fusion-builder-row-1 .fusion-filters .fusion-filter.fusion-active a,
.fusion-fullwidth.fusion-builder-row-1 .fusion-date-and-formats .fusion-format-box,
.fusion-fullwidth.fusion-builder-row-1 .fusion-popover,
.fusion-fullwidth.fusion-builder-row-1 .tooltip-shortcode {
  color: #ffa626;
}

#main .fusion-fullwidth.fusion-builder-row-1 .post .blog-shortcode-post-title a:hover {
  color: #ffa626;
}
</style>
<div
class="fusion-fullwidth fullwidth-box fusion-builder-row-2 nonhundred-percent-fullwidth non-hundred-percent-height-scrolling"
style='background-color: rgba(255,255,255,0);background-position: center center;background-repeat: no-repeat;padding-top:0px;padding-right:30px;padding-bottom:0px;padding-left:30px;margin-top: -150px;'>
<div class="fusion-builder-row fusion-row ">
  <div
    class="fusion-layout-column fusion_builder_column fusion_builder_column_1_5 fusion-builder-column-1 fusion-one-fifth fusion-column-first 1_5"
    style='margin-top:0px;margin-bottom:0px;width:20%;width:calc(20% - ( ( 4% + 4% ) * 0.2 ) );margin-right: 4%;'>
    <div class="fusion-column-wrapper"
      style="background-color:rgba(239,239,239,0);padding: 0px 30px 30px 0px;background-position:left top;background-repeat:no-repeat;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;"
      data-bg-url="">
      <div class="fusion-clearfix"></div>
    </div>
  </div>
  <div
    class="fusion-layout-column fusion_builder_column fusion_builder_column_3_5 fusion-builder-column-2 fusion-three-fifth 3_5"
    style='margin-top:0px;margin-bottom:0px;width:60%;width:calc(60% - ( ( 4% + 4% ) * 0.6 ) );margin-right: 4%;'>
    <div class="fusion-column-wrapper"
      style="background-color:var(--ng-app-mid-grey-color);padding: 30px 30px 30px 30px;background-position:left top;background-repeat:no-repeat;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;"
      data-bg-url="">
      <div class="fusion-text">
        <h3 style="text-align: center;">PASSWORD PERSA?</h3>
      </div>
      <div class="fusion-sep-clear"></div>
      <div class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto;margin-right: auto;margin-top:10px;"></div>
      <form [formGroup]="lostPasswordForm" id="lostpassword-appform" [hidden]="done">
        <ul class="fusion-checklist fusion-checklist-1" style="font-size:14px;line-height:23.8px;">
          <li class="fusion-li-item"><span style="height:23.8px;width:23.8px;margin-right:9.8px;"
              class="icon-wrapper circle-no"><i class="fusion-li-icon fa-user-edit fas"
                style="color:#717171;"></i></span>
            <div class="fusion-li-item-content" style="margin-left:33.6px;">
              <p>USER NAME</p>
            </div>
          </li>
        </ul>
        <div class="fusion-button-wrapper fusion-align-block">
          <style type="text/css">
            .fusion-button.button-1 .fusion-button-text,
            .fusion-button.button-1 i {
              color: #a5a5a5;
            }

            .fusion-button.button-1 .fusion-button-icon-divider {
              border-color: #a5a5a5;
            }

            .fusion-button.button-1:hover .fusion-button-text,
            .fusion-button.button-1:hover i,
            .fusion-button.button-1:focus .fusion-button-text,
            .fusion-button.button-1:focus i,
            .fusion-button.button-1:active .fusion-button-text,
            .fusion-button.button-1:active {
              color: #ffffff;
            }

            .fusion-button.button-1:hover .fusion-button-icon-divider,
            .fusion-button.button-1:hover .fusion-button-icon-divider,
            .fusion-button.button-1:active .fusion-button-icon-divider {
              border-color: #ffffff;
            }

            .fusion-button.button-1:hover,
            .fusion-button.button-1:focus,
            .fusion-button.button-1:active {
              border-color: #ffffff;
            }

            .fusion-button.button-1 {
              border-color: #333333;
              border-radius: 0px;
            }

            .fusion-button.button-1 {
              background: #ffffff;
            }

            .fusion-button.button-1:hover,
            .button-1:focus,
            .fusion-button.button-1:active {
              background: #ffffff;
            }
          </style>
          <input class="ng-app-input" type="email" placeholder="La mail con cui ti sei registrato" formControlName="loginUsername" (click)="resetError()" required email>
          <div [ngStyle]="{'visibility':lostPasswordForm.get('loginUsername').valid || lostPasswordForm.get('loginUsername').pristine ? 'hidden':'visible'}" class="ng-alert">
            Inserire l'email con cui ci si è registrati.
          </div>
        </div>
        <div class="fusion-sep-clear"></div>
        <div class="fusion-separator fusion-full-width-sep sep-none"
          style="margin-left: auto;margin-right: auto;margin-top:30px;"></div>
        <div class="fusion-text">
          <h5>Controlla la tua casella di posta: riceverai un link con cui reimpostare la tua nuova password.</h5>
        </div>
        <div class="fusion-sep-clear"></div>
        <div class="fusion-separator fusion-full-width-sep sep-none"
          style="margin-left: auto;margin-right: auto;margin-top:30px;"></div>
        <div [ngStyle]="{'visibility':error === 'no_error' ? 'hidden':'visible'}" class="ng-alert">
          {{error}}
          <div class="fusion-sep-clear"></div>
          <div class="fusion-separator fusion-full-width-sep sep-none"
            style="margin-left: auto;margin-right: auto;margin-top:30px;"></div>
        </div>
        <div class="ng-spinner">
          <img *ngIf="loading" src="/wp-content/themes/Avada-Child-Theme/images/spinner_yellow.svg"/>
        </div>
        <div class="fusion-button-wrapper fusion-aligncenter">
          <style type="text/css">
            .fusion-button.button-2 {
              border-radius: 0px;
            }
          </style><a (click)="lostPasswordSubmitHandler()"
            class="fusion-button button-flat fusion-button-default-size button-default button-2 fusion-button-default-span fusion-button-default-type"
            target="_self"><span class="fusion-button-text">INVIA EMAIL</span></a>
        </div>
        <div class="fusion-clearfix"></div>
      </form>
      <div [hidden]="done == false">
        <div class="fusion-text" >
          <h5>La mail è stata inviata, controlla la tua casella di posta.</h5>
        </div>
        <div class="fusion-sep-clear"></div>
        <div class="fusion-separator fusion-full-width-sep sep-none"
          style="margin-left: auto;margin-right: auto;margin-top:30px;"></div>
      </div>
    </div>
  </div>
  <div
    class="fusion-layout-column fusion_builder_column fusion_builder_column_1_5 fusion-builder-column-3 fusion-one-fifth fusion-column-last 1_5"
    style='margin-top:0px;margin-bottom:0px;width:20%;width:calc(20% - ( ( 4% + 4% ) * 0.2 ) );'>
    <div class="fusion-column-wrapper"
      style="background-color:rgba(239,239,239,0);padding: 0px 30px 30px 0px;background-position:left top;background-repeat:no-repeat;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;"
      data-bg-url="">
      <div class="fusion-clearfix"></div>
    </div>
  </div>
</div>
</div>
<style type="text/css">
.fusion-fullwidth.fusion-builder-row-2 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link),
.fusion-fullwidth.fusion-builder-row-2 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):before,
.fusion-fullwidth.fusion-builder-row-2 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):after {
  color: #ffa626;
}

.fusion-fullwidth.fusion-builder-row-2 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):hover,
.fusion-fullwidth.fusion-builder-row-2 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):hover:before,
.fusion-fullwidth.fusion-builder-row-2 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):hover:after {
  color: #ffa626;
}

.fusion-fullwidth.fusion-builder-row-2 .pagination a.inactive:hover,
.fusion-fullwidth.fusion-builder-row-2 .fusion-filters .fusion-filter.fusion-active a {
  border-color: #ffa626;
}

.fusion-fullwidth.fusion-builder-row-2 .pagination .current {
  border-color: #ffa626;
  background-color: #ffa626;
}

.fusion-fullwidth.fusion-builder-row-2 .fusion-filters .fusion-filter.fusion-active a,
.fusion-fullwidth.fusion-builder-row-2 .fusion-date-and-formats .fusion-format-box,
.fusion-fullwidth.fusion-builder-row-2 .fusion-popover,
.fusion-fullwidth.fusion-builder-row-2 .tooltip-shortcode {
  color: #ffa626;
}

#main .fusion-fullwidth.fusion-builder-row-2 .post .blog-shortcode-post-title a:hover {
  color: #ffa626;
}
</style>